import { schemaTypes } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import moment from "moment";
import { changeVehicle } from "./historyReport/historyReport";

const processData = (respObj, callback) => {
  let historyData = [];

  for (let idx in respObj) {
    let hisObj = {};
    let rData = respObj[idx];
    if (rData.cmdStatuses.length) {
      for (let ldx in rData.cmdStatuses) {
        let cmdData = rData.cmdStatuses[ldx];
        hisObj.batteryid = cmdData.batteryid;
        hisObj.cmdtype =
          cmdData.cmd?.type && cmdData.cmd?.mode
            ? `${cmdData.cmd.type}_${cmdData.cmd.mode}`
            : "";
        hisObj.cmdid = cmdData.cmdid;
        hisObj.cmdsrc = cmdData.cmdsrc;
        hisObj.createdby = cmdData.createdby;
        hisObj.pickedtime = null;
        hisObj.executiontime = null;
        if (cmdData.status && cmdData.status.length) {
          for (let rdx in cmdData.status) {
            if (cmdData.status[rdx].cmdstatus === "CMD_PICKED_UP_BY_SERVER") {
              hisObj.pickedtime = moment(
                parseInt(cmdData.status[rdx].timestamp, 10)
              ).format("DD-MMM-YYYY HH:mm:ss");
            }
            if (
              cmdData.status[rdx].cmdstatus === "DEVICE_CMD_EXECUTION_SUCCESS"
            ) {
              hisObj.executiontime = moment(
                parseInt(cmdData.status[rdx].timestamp, 10)
              ).format("DD-MMM-YYYY HH:mm:ss");
            }
          }
        }
      }
      if (hisObj.pickedtime !== null && hisObj.executiontime !== null)
        historyData.push(hisObj);
    }
  }
  callback(historyData);
};

const getHistory = (schema, data, store) => {
  schema.finalData = null;
  let saveState = null;
  let tableStateData = null;
  if (!data.vehicle.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError: true,
      },
    });
    return;
  }
  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  if (starttime > endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError: true,
      },
    });
    return;
  }
  if (endtime - starttime > 1000 * 60 * 60 * 24 * 31) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "You can't select a date range of more than 31 days",
        content: "You can't select date range of more than 31 days",
        createAt: Date.now(),
        autoClose: 8000,
        showError: true,
      },
    });
    return;
  }
  if (window.setReportWindowTabBusy)
    window.setReportWindowTabBusy(schema, true);
  if (schema.content[0].ref) {
    schema.content[0].ref.setBusy(true);
  }

  if (data.vehicle && data.vehicle.length) {
    const handleSuccess = (resp) => {
      window.dataForAll = resp;
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      processData(resp, (data) => {
        schema.finalData = data;
        if (tableStateData && tableStateData[0]) {
          tableStateData[0].body = data;
          tableStateData[0].busy = false;
          saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
        }
        if (schema.content[0].ref) {
          saveState = schema.content[0].ref.props.saveState;
          tableStateData = [
            schema.content[0].ref.state,
            schema.content[0].ref.props.schemaKey,
            schema.content[0].ref.props.data,
          ];
          schema.content[0].ref.setData(data);
          schema.content[0].ref.setBusy(false);
        }
      });
    };

    let body = {
      vehiclenos: data.vehicle.map((item) => {
        return item.data.vehicleno;
      }),
      starttime: data.starttime.unix() * 1000,
      endtime: data.endtime.unix() * 1000,
    };

    ReportAPIs.getImmobReport(body).then(handleSuccess, (r) => {
      handleSuccess({});
    });
  } else {
    window.graphDataErr = "";
    window.dataForAll = null;
    window.graphDataErr = "Please Select Vehicle";

    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if (window.InGraphControlForceUpdate) {
      window.InGraphControlForceUpdate();
    }
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }
};

const schema = {
  key: "immob_report",
  name: "IMMOB Report",
  finalData: null,
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },

    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get IMMOB Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: () => {
        if (schema.finalData) {
          setTimeout(() => {
            JSONToCSVConvertor(schema.finalData, "immob_report", false);
          }, 500);
        }
      },
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "batteryid", name: "Battery ID" },
        { key: "cmdtype", name: "Command Type", timestamp: "alarmtimestamp" },
        { key: "cmdid", name: "Command ID", width: 1.3 },
        { key: "cmdsrc", name: "Command From" },
        { key: "createdby", name: "Send By" },
        { key: "pickedtime", name: "CMD Send At" },
        { key: "executiontime", name: " CMD Executed At" },
      ],
    },
  ],
};
export default schema;
